import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
@Component({
  selector: 'app-location-alert-dialog',
  templateUrl: './location-alert-dialog.component.html',
  styleUrls: ['./location-alert-dialog.component.scss']
})
export class LocationAlertDialogComponent{
  constructor(public dialogRef: MatDialogRef<LocationAlertDialogComponent>,  private route: Router) { }
  closePopup(flag = false): void {
    this.dialogRef.close({checked : flag});
  }
}
